import { DOTS, usePagination } from '../hooks';
import { FiChevronLeft, FiChevronRight } from 'react-icons/fi';

//eslint-disable-next-line
import React from 'react';
import classnames from 'classnames';

type paginationPropsType = {
    onPageChange: (page: number) => void;
    totalCount: number;
    siblingCount: number;
    currentPage: number;
    pageSize: number;
    className: string;
};

export const Pagination = (props: paginationPropsType | any) => {
    const {
        onPageChange,
        totalCount,
        siblingCount = 1,
        currentPage,
        pageSize,
        className
    } = props;

    const paginationRange: [] | any = usePagination({
        currentPage,
        totalCount,
        siblingCount,
        pageSize
    });

    if (currentPage === 0 || paginationRange.length < 2) {
        return null;
    }

    const onNext = () => {
        onPageChange(currentPage + 1);
    };

    const onPrevious = () => {
        onPageChange(currentPage - 1);
    };

    const lastPage = paginationRange[paginationRange.length - 1];

    return (
        <ul
            className={classnames('pagination-container', { [className]: className })}
        >
            <li
                className={classnames('pagination-item', {
                    disabled: currentPage === 1
                })}
                style={{
                    height: 40,
                    width: 40
                }}
                onClick={onPrevious}
            >
                <FiChevronLeft size={18} />
            </li>
            {paginationRange.map((pageNumber: any, index: number) => {
                if (pageNumber === DOTS) {
                    return <li key={index} className="pagination-item dots">&#8230;</li>;
                }

                return (
                    <li
                        key={index}
                        className={classnames('pagination-item', {
                            selected: pageNumber === currentPage
                        })}
                        onClick={() => onPageChange(pageNumber)}
                    >
                        {pageNumber}
                    </li>
                );
            })}
            <li
                className={classnames('pagination-item', {
                    disabled: currentPage === lastPage
                })}
                style={{
                    height: 40,
                    width: 40
                }}
                onClick={onNext}
            >
                <FiChevronRight size={18} />
            </li>
        </ul>
    );
};